"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromDto = exports.toDto = void 0;
const json_crdt_patch_1 = require("json-joy/lib/json-crdt-patch");
const toDto = (sid, id) => {
    const dto = [id.time];
    if (id.sid !== sid)
        dto.push(id.sid);
    return dto;
};
exports.toDto = toDto;
const fromDto = (sid, dto) => {
    const [time, dtoSid = sid] = dto;
    return new json_crdt_patch_1.Timestamp(dtoSid, time);
};
exports.fromDto = fromDto;
